module.exports = __webpack_public_path__ + "img/finland.4397c9c.webp";